import { NOTIFICATION_TYPE } from '../constants/Notifications';
import { diContainer, serviceNames } from '../diContainer/diContainer';
import NotificationsCollection from '../domain/entities/Notification/NotificationsCollection';
import ValidateAndSubmitAddressesUseCase from './ValidateAndSubmitAddressesUseCase';

class SaveCourierAddressUseCase {
  private isBillingSameAsShipping: boolean;

  private notificationsCollection: NotificationsCollection;

  private withUpsValidation: boolean;

  constructor(isBillingSameAsShipping: boolean, withUpsValidation: boolean) {
    this.isBillingSameAsShipping = isBillingSameAsShipping;
    this.notificationsCollection = diContainer.get(serviceNames.notificationsCollection);
    this.withUpsValidation = withUpsValidation;
  }

  public async execute(): Promise<void> {
    this.notificationsCollection.clearNotifications(undefined, NOTIFICATION_TYPE.DANGER);
    await new ValidateAndSubmitAddressesUseCase({
      isBillingSameAsShipping: this.isBillingSameAsShipping,
      withUpsValidation: this.withUpsValidation,
    }).execute();
  }
}

export default SaveCourierAddressUseCase;
